var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.servicepointDetail)?_c('div',[_c('servicepoint-editable-detail',{ref:"servicepointEditableDetail",attrs:{"detail":_vm.servicepointDetail},on:{"fetch-servicepoint-required":_vm.handleFetchServicepointRequired}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }